import { Component } from '@angular/core';

@Component({
  selector: 'i-checkmark',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 32" fill="none">
      <path
        d="M39.7244 2.78374C40.5783 4.9931 39.3808 6.50572 37.0632 7.99572C35.193 9.19794 32.8104 10.5003 30.2858 12.727C25.5813 16.8764 21.6047 21.8826 18.0106 27.0032C17.3304 27.9724 16.6579 28.9483 16.0233 29.9482C15.2068 31.2399 13.739 32.0218 12.1651 32.0022C10.5908 31.9826 9.14489 31.1649 8.36379 29.8526C5.90453 25.7211 4.15471 24.6792 3.75888 24.4852C1.62977 24.1685 0 22.4014 0 20.2686C0 17.9122 1.98994 16.0019 4.44468 16.0019C6.17824 16.0659 7.78745 16.7467 9.21586 17.7066C10.1282 18.3197 11.0947 19.1305 12.0999 20.1978C15.7164 15.265 19.676 10.4961 24.2717 6.44284C27.1518 3.90261 30.4816 1.52482 34.0111 0.267641C36.3127 -0.552105 38.8705 0.574405 39.7244 2.78374Z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconCheckmark {}
